import ChannelList from '@/pages/wechat/channel-list'
import TariffList from '@/pages/wechat/tariff-list'
import MenuManage from '@/pages/wechat/menu-manage'
import WxQrCode from '@/pages/wechat/wx-qrCode'
import MinprogramManage from '@/pages/wechat/minprogram-manage'

export const channelList = {
  path: 'wechat/channelList',
  component: ChannelList
}

export const tariffList = {
  path: 'wechat/tariffList',
  component: TariffList
}

export const menuManage = {
  path: 'wechat/menuManage',
  component: MenuManage
}

export const wxQrCode = {
  path: 'wechat/wxQrCode',
  component: WxQrCode
}

export const minprogramManage = {
  path: 'wechat/minprogramManage',
  component: MinprogramManage
}



// WEBPACK FOOTER //
// ./src/router/wechat.js